import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges } from '@angular/core';
import { IconsModule, SVGIcon } from '@progress/kendo-angular-icons';
import { filterIcon } from '@progress/kendo-svg-icons';
import { FilterBase } from 'src/app/shared/grid/filter-base';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

@Component({
    selector: 'grid-clear-filter-popup',
    template: ` <div
        class="k-grid-filter"
        (click)="resetFilter()"
        [class.k-state-active]="isFilterActive">
        <kendo-svgicon
            #popupAnchor
            [icon]="filterIcon"
            [size]="'small'"></kendo-svgicon>
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [IconsModule]
})
export class GridClearFilterPopupComponent extends FilterBase implements OnChanges {
    isFilterActive = false;
    filterIcon: SVGIcon = filterIcon;

    updateIsFilterActive() {
        const value = this.getLatestFilterValue();
        this.isFilterActive = !isEmpty(value) && value !== '';
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filter']) {
            this.updateIsFilterActive();
        }
    }

    resetFilter(): void {
        if (this.isFilterActive) {
            this.trimFilterByField(this.filter, this.field);
            this.submitFilter();
            this.updateIsFilterActive();
        }
    }
}
